import Select from 'react-select'
import Search from './svg/Search'
function CustomMultiselectSearch(props) {
    const DropdownIndicator = props => {
        return (
            <div className="mr-2">
                <Search />
            </div>
        )
    }
    const customStyles = {
        valueContainer: (provided, state) => ({
            ...provided,
            height: '52px',
            overflow: 'innerhit',
        }),
        placeholder: (base, state) => ({
            ...base,
            display: state.isFocused ? 'none' : 'block',
            fontSize: '1em',
            fontWeight: 400,
        }),
        input: base => ({
            ...base,
            marginTop: '-10px',
            marginBottom: '4px',
            height: '52px',
        }),
        menu: (provided, state) => ({
            ...provided,
            paddingTop: '5px',
            paddingBottom: '5px',
            paddingRight: '5px',
            marginTop: 3,
            borderColor: '#f73c39',
            backgroundColor: '#F8F8F8',
            borderStyle: 'solid',
            borderWidth: '3px',
            borderRadius: '16px',
        }),
        option: (provided, state) => ({
            ...provided,
            borderWidth: '3px',
            borderRadius: '16px',
            borderColor: 'transparent',
            '&:hover': {
                fontWeight: 'bold',
            },
            overflow: 'auto',
            backgroundColor: 'transparent',
            color: state.isSelected ? '#f73c39' : 'black',
            fontWeight: state.isSelected ? 'bold' : 'normal',
            marginTop: 0,
            padding: 10,
        }),
        control: (base, state) => ({
            ...base,
            height: '53px',
            borderStyle: 'solid',
            borderWidth: '3px',
            borderRadius: '16px',
            borderColor: state.isFocused ? '#f73c39' : 'transparent',
            backgroundColor: '#F8F8F8',
            boxShadow: 'none',
            '&:hover': {
                borderColor: '#f73c39',
            },

            '&:focus': {
                borderColor: '#f73c39',
            },
        }),
        multiValue: styles => ({
            ...styles,
        }),
    }
    return (
        <Select
            components={{
                IndicatorSeparator: () => null,
                DropdownIndicator,
            }}
            isMulti
            isSearchable={true}
            styles={customStyles}
            options={props.options}
            value={props.value}
            className="basic-multi-select"
            classNamePrefix="select"
            id={props.id}
            onChange={selectedOptions => props.onChange(selectedOptions)}
            placeholder={props.placeholder}
            controlShouldRenderValue={false}
            isClearable={false}
        />
    )
}

export default CustomMultiselectSearch
